import enUS from './en-us';
import esCL from './es-cl';

export default {
  'en-US': enUS,
  es: esCL,
};



// WEBPACK FOOTER //
// ./src/i18n/index.js